import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Card, Form, Button, FormControl, Alert } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, Link, useParams } from "react-router-dom";
import API from "../../services/axiosInstance"
import Permission from "../security/permission";
import { AUTH_CODE } from "../security/authCodes";
import { FormLoader, useFormLoader } from '../common_modules/loader';
import { useAuth } from "../security/authContext";
// import useSubmitPrevent from "../utils/SubmitPrevent";
import usePreventMultiClick from "../utils/SubmitPrevent";

const InvoiceSetting = () => {
    // const [invoiceSetting, setInvoiceSetting] = useState([]);
    const [publisherName, setPublisherName] = useState("");
    const [currency, setCurrency] = useState([]);
    const [invoiceData, setInvoiceData] = useState(null);

    const { register, handleSubmit, reset, watch, getValues, formState: { errors } } = useForm({
        shouldUnregister: true,
        defaultValues: {
            payment_type: "1"
        }
    });
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const { id, guid } = useParams();
    // const pubId = state?.publisherId;
    // const pubGuid = state?.publisherGuid;

    const paymentType = watch("payment_type");
    const approvalStatus = watch("status");
    const { permissions } = useAuth();
    // custom hook loader
    const { isLoading, startLoading, stopLoading } = useFormLoader(); 

    // const submittingRef = useSubmitPrevent();
    const { btnClicked, setBtnClicked } = usePreventMultiClick();

    const mapInvoiceApiToForm = (data) => ({
        currency:data.currency,
        payment_type: String(data.paymentType),
        amount: data.payout,
        type: data.type,
        proration_lower_limit: data.prorationLowerLimit,
        proration_upper_limit: data.prorationUpperLimit,
        monthly_guaranteed: data.monthlyGuaranteedQuantity,
        percentage: data.percentage,
        account_manager_name: data.accountManagerName,
        account_manager_email: data.accountManagerEmailId,
        ops_account_head_email: data.opsAccountHeadEmailId,
        pub_acc_manager_email_to: data.publisherAccManagerEmailTO,
        pub_acc_manager_email_cc: data.publisherAccManagerEmailCC,
        ops_acc_manager_email_to: data.operationsAccManagerEmailTO,
        ops_acc_manager_email_cc: data.operationsAccManagerEmailCC,
        language: data.addLanguage,
        reporting_type: data.reportingType,
        gam_onboarding: data.onboardingDateChange,
        status: Number(data.approvalStatus),
    });


    // get api 
    const invoiceSettingRef = useRef(null);
    const getInvoiceSetting = async () => {
        try {
            const res = await API.get(`publisher/invoice/setting/${guid}`);
            // setInvoiceSetting(invoiceSettingRes?.data?.data);
            const data = res?.data?.data;
            setPublisherName(res?.data?.name);
            invoiceSettingRef.current = data || null;
            setInvoiceData(res.data.data);
            console.log(data.id);

            // if (data) {
            //     reset(mapInvoiceApiToForm(data));
            //     setTimeout(() => {
            //     console.log("watch after reset:", watch("currency"));
            // }, 0);
            // }
        } catch {
            console.error(errors);
        } finally {
        }
    }
    //   email validation
    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const toCommaSeparated = (value = "") => value.split(/[\n,]+/).map(v => v.trim()).filter(v => v && isValidEmail(v)).join("\n");

    // Common trim function
    const trimPayload = (payload) => {
    return Object.fromEntries(
        Object.entries(payload).map(([key, value]) => [
            key,
            typeof value === "string" ? value.trim() : value
        ])
    );
};
    // Show the reminder on Update click, even if validation blocks saving.
    const showGamReviewAlert = () => {
        if (btnClicked) return;

        const originalInvoice = invoiceSettingRef.current;
        if (!originalInvoice?.id) return;

        const data = getValues();
        const selectedPaymentType = String(data.payment_type ?? "");
        const paymentTypeChanged =
            selectedPaymentType !== String(originalInvoice.paymentType ?? "");
        const isFixedRevenue = ["0", "2"].includes(selectedPaymentType);
        const reportingTypeChanged = isFixedRevenue &&
            String(data.reporting_type ?? "") !== String(originalInvoice.reportingType ?? "");

        if (paymentTypeChanged || reportingTypeChanged) {
            window.alert("Please review & update the GAM settings to ensure the correct metrics are reflected on the publisher's dashboard.");
        }
    };

    // send payload   
    const onSubmit = async (data) => {
        if(btnClicked) return;
        setBtnClicked(true);
        // if(submittingRef.current) return;
        // submittingRef.current = true;
        startLoading();

        const selectedPaymentType = String(data.payment_type);

        const selectedStatus =
        Number(invoiceSettingRef.current?.approvalStatus) === 9
            ? 9
            : Number(data.status ?? 5);

        const isFixedRevenue = selectedPaymentType === "0" || selectedPaymentType === "2";

        const payload = {
            currency: Number(data.currency),
            paymentType: selectedPaymentType,

            // payout: Number(data.amount),
            // type: Number(data.type),

            // prorationLowerLimit: data.proration_lower_limit,
            // prorationUpperLimit: data.proration_upper_limit,
            // monthlyGuaranteedQuantity: data.monthly_guaranteed,
            // percentage: data.percentage,

            accountManagerName: data.account_manager_name,
            accountManagerEmailId: data.account_manager_email,
            opsAccountHeadEmailId: data.ops_account_head_email,

            publisherAccManagerEmailTO: data.pub_acc_manager_email_to,
            publisherAccManagerEmailCC: data.pub_acc_manager_email_cc,

            operationsAccManagerEmailTO: data.ops_acc_manager_email_to,
            operationsAccManagerEmailCC: data.ops_acc_manager_email_cc,

            approvalStatus: selectedStatus,
            addLanguage: Number(data.language),

            // reportingType: Number(data.reporting_type),

            // onboardingDateChange: Boolean(data.gam_onboarding),

            id: invoiceSettingRef.current?.id || '',
            accountId: id || '',
            accountGuid: guid || '',
            approvalDate: invoiceSettingRef.current?.approvalDate || '',
            approvedBy: invoiceSettingRef.current?.approvedBy || '',
            remainderCount: invoiceSettingRef.current?.remainderCount || '',
            videoLabel: invoiceSettingRef.current?.videoLabel || '',

            // Revenue Sharing OR Fixed Revenue With eCPM
            ...(["1", "2"].includes(selectedPaymentType) && {
                percentage: data.percentage
            }),

            // Fixed Revenue OR Fixed Revenue With eCPM
            ...(isFixedRevenue && {
                payout: Number(data.amount),
                type: Number(data.type),
                prorationLowerLimit: data.proration_lower_limit,
                prorationUpperLimit: data.proration_upper_limit,
                monthlyGuaranteedQuantity: data.monthly_guaranteed,
                reportingType: Number(data.reporting_type)
            }),

            // Only when GAM onboarding field is visible
            ...(selectedStatus === 9 && {
                onboardingDateChange: data.gam_onboarding,
            })
        };
        // Automatically trim all string values
        const cleanedPayload = trimPayload(payload);

        try {
            const sendSettingRes = await API.put('publisher/invoice/setting/save',
                cleanedPayload,
            )
            if (sendSettingRes?.data?.status === "Success") {
                alert('Setting updated successfully');
                reset();
                navigate('/active-publisher');
            } else {
                alert(sendSettingRes?.data?.message);
            }

        } catch (error) {
            console.error("API Error:", error);
            alert(error?.sendSettingRes?.data?.message || "Something went wrong!");
        } finally {
            // submittingRef.current = false;
            setBtnClicked(false);
            stopLoading();
        }
    }

        // currency api
    const currencyApi = async () => {
        try {
            const currencyRes = await API.get(`/publisher/currency/list/${id}`)
            setCurrency(currencyRes?.data?.data);
            // setPublisherName(currencyRes?.data?.name);
        } catch (error) { console.error(error); } 
    }
    
    useEffect(() => {
        const fetchData = async ()=> {
            startLoading()
            try {
                await Promise.all([
                    currencyApi(),
                    guid ? getInvoiceSetting() : Promise.resolve()
                ])
            } finally {
                stopLoading();
            }
        };
        fetchData();
        // if (guid) getInvoiceSetting();
        // currencyApi();
    }, [guid, id]);

    useEffect(() => {
    if (currency.length > 0 && invoiceData) {
        reset(mapInvoiceApiToForm(invoiceData));
    }
}, [currency, invoiceData, reset]);

    const currentStatus = invoiceSettingRef?.current?.approvalStatus;

    const isNewInvoice = !invoiceSettingRef?.current?.id;

    const isApproved = currentStatus === 9;

    // const isApproved = invoiceSettingRef?.current?.approvalStatus === 9;

    const canApprove = permissions?.includes("fullAccess") || permissions?.includes(AUTH_CODE.invoiceSetting.approveInvoiceSetting);
    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <Card className="p-3 instreamRows">
                <div className="breadCrumb gradient-bg">
                    <Link to={'/dashboard'}><span>Home</span></Link>
                    <Link to={'/active-publisher'}><span>Active Publisher</span></Link>
                    {/* <span>{publisherName}</span> */}
                    <Link to={`/publisher/info/${id}/${guid}`}><span>{publisherName}</span></Link>
                    <span>Invoice Setting</span>
                    {/* <span>{invoiceSettingRef?.current?.id ? "Update" : "Create"} Invoice Setting</span> */}
                    {/* <span>{id}</span> */}
                </div>
                <span className="text-danger" style={{ fontSize: "12px" }}>All fields marked with * are mandatory</span>
                <h6 className="title mb-5">Manage Invoice Setting</h6>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Card className="p-3">
                        <Row>
                            <Col md={3}>
                                <label>Payment Currency <span className="text-danger">*</span> </label>
                            </Col>
                            <Col md={5}>
                                <Form.Select {...register("currency", { required: "Currency is required" })}>
                                    {/* <option value="1" >INR</option>
                                    <option value="2" >USD</option>
                                    <option value="3" >HKD</option>
                                    <option value="4" >EUR</option> */}
                                <option value="">Select Currency</option>
                                {
                                    currency.map((curr) => (
                                        <option key={curr.id} value={curr?.id}>{curr?.currencyCode}</option>
                                    ))
                                }
                                </Form.Select>
                                {errors.currency && <p className="text-danger">{errors.currency.message}</p>}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Payment Type <span className="text-danger">*</span> </label>
                            </Col>
                            <Col md={5}>
                                <Form.Select name="payment_type" {...register("payment_type", { required: "Payment type is required" })}>
                                    <option value="1" >Revenue Sharing</option>
                                    <option value="0" >Fixed Revenue</option>
                                    <option value="2" >Fixed Revenue With eCPM</option>
                                </Form.Select>
                                {errors.payment_type && <p className="text-danger">{errors.payment_type.message}</p>}

                            </Col>
                        </Row>
                        {paymentType === "1" && (
                            <Row>
                                <Col md={3}>
                                    <label>Percentage <span className="text-danger">*</span></label>
                                </Col>
                                <Col md={5}>
                                    <Form.Control type="number" step="any" placeholder="Enter here..." {...register("percentage", { required: "Percentage is required" })} />
                                </Col>
                            </Row>
                        )
                        }
                        {paymentType === "2" && (
                            <Row>
                                <Col md={3}>
                                    <label>eCPM value</label>
                                </Col>
                                <Col md={5}>
                                    <Form.Control type="number" step="any" placeholder="Enter here..." {...register("percentage")} />
                                </Col>
                            </Row>
                        )
                        }
                        {
                            (paymentType === "0" || paymentType === "2") && (
                                <>
                                    <Row>
                                        <Col md={3}>
                                            <label>Reporting Type</label>
                                        </Col>
                                        <Col md={5}>
                                            <Form.Select name="reporting_type" {...register("reporting_type")}>
                                                <option value="0" >No Dashboard Data</option>
                                                <option value="1" >Page Views Dashboard</option>
                                                <option value="2" >GAM report based on user role setting</option>
                                                {/* <option value="3" >Video PVs Only</option> */}
                                                {/* <option value="4" >Video PVs + Page Views</option> */}
                                            </Form.Select>
                                        </Col>
                                    </Row>
                                    {/* <Row>
                                    <Col md={3}>
                                        <label>PVs Display Name</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Control type="text" name="pvs" placeholder="Enter here..." {...register("pvs")} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <label>Video PVs Display Name</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Control type="text" name="video_pvs" placeholder="Enter here..." {...register("video_pvs")} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <label>Fixed Revenue Display Name</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Control type="text" name="fixed_revenue" placeholder="Enter here..." {...register("fixed_revenue")} />
                                    </Col>
                                </Row> */}
                                    <Row>
                                        <Col md={3}>
                                            <label>Type <span className="text-danger">*</span> </label>
                                        </Col>
                                        <Col md={5}>
                                            <Form.Select name="type" {...register("type", { required: "Type is required" })}>
                                                <option value="0" >Page views</option>
                                                <option value="1" >Impression</option>
                                                <option value="2" >Request</option>
                                            </Form.Select>
                                            {errors.type && <p className="text-danger">{errors.type.message}</p>}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3}>
                                            <label>Monthly Guaranteed Quantity</label>
                                        </Col>
                                        <Col md={5}>
                                            <Form.Control type="number" name="monthly_guaranteed" placeholder="Enter here..." {...register("monthly_guaranteed")} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3}>
                                            <label>Amount <span className="text-danger">*</span> </label>
                                        </Col>
                                        <Col md={5}>
                                            <Form.Control type="number" name="amount" placeholder="Enter here..." {...register("amount", { required: "Amount is required" })} />
                                            {errors.amount && <p className="text-danger">{errors.amount.message}</p>}
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col md={3}>
                                            <label>Proration Upper Limit (0-100%) <span className="text-danger">*</span> </label>
                                        </Col>
                                        <Col md={5}>
                                            <Form.Control type="number" name="proration_upper_limit" placeholder="Enter here..." {...register("proration_upper_limit", { required: "Proration Upper Limit is required" })} />
                                            {errors.proration_upper_limit && <p className="text-danger">{errors.proration_upper_limit.message}</p>}
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col md={3}>
                                            <label>Proration Lower Limit (0-100%) <span className="text-danger">*</span> </label>
                                        </Col>
                                        <Col md={5}>
                                            <Form.Control type="number" name="proration_lower_limit" placeholder="Enter here..." {...register("proration_lower_limit", { required: "Proration Lower Limit is required" })} />
                                            {errors.proration_lower_limit && <p className="text-danger">{errors.proration_lower_limit.message}</p>}
                                        </Col>

                                    </Row>
                                </>
                            )
                        }
                        <Row>
                            <Col md={3}>
                                <label>Account Manager Name <span className="text-danger">*</span> </label>
                            </Col>
                            <Col md={5}>
                                <Form.Control type="text" name="account_manager_name" placeholder="Enter here..." 
                                {...register("account_manager_name", {
                                        setValueAs: (value) =>
                                            typeof value === "string" ? value.trim() : value,
                                        required: "Account manager name is required"
                                })} 
                                />
                                {errors.account_manager_name && <p className="text-danger">{errors.account_manager_name.message}</p>}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Account Manager Email Id <span className="text-danger">*</span> </label>
                            </Col>
                            <Col md={5}>
                                <Form.Control type="text" name="account_manager_email" placeholder="Enter here..." 
                                {...register("account_manager_email", {
                                        setValueAs: (value) =>
                                            typeof value === "string" ? value.trim() : value,
                                        required: "Account Manager Email Id is required"
                                })} />
                                {errors.account_manager_email && <p className="text-danger">{errors.account_manager_email.message}</p>}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Ops Account Head email ID <span className="text-danger">*</span> </label>
                            </Col>
                            <Col md={5}>
                                <Form.Control type="text" name="ops_account_head_email" placeholder="Enter here..." 
                                {...register("ops_account_head_email", {
                                        setValueAs: (value) =>
                                            typeof value === "string" ? value.trim() : value,
                                        required: "Ops Account Head email ID is required"
                                })} />
                                {errors.ops_account_head_email && <p className="text-danger">{errors.ops_account_head_email.message}</p>}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Publisher Account manager email IDs TO</label>
                            </Col>
                            <Col md={5}>
                                <Form.Control as="textarea" name="pub_acc_manager_email_to" rows={4} placeholder="Enter here..." {...register("pub_acc_manager_email_to")} />
                                <span className="info">each line have 1 email id, press enter for next line</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Publisher Account manager email IDs CC</label>
                            </Col>
                            <Col md={5}>
                                <Form.Control as="textarea" name="pub_acc_manager_email_cc" rows={4} placeholder="Enter here..." {...register("pub_acc_manager_email_cc")} />
                                <span className="info">each line have 1 email id, press enter for next line</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Operations Account manager email IDs TO</label>
                            </Col>
                            <Col md={5}>
                                <Form.Control as="textarea" name="ops_acc_manager_email_to" rows={4} placeholder="Enter here..." {...register("ops_acc_manager_email_to")} />
                                <span className="info">each line have 1 email id, press enter for next line</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Operations Account manager email IDs CC</label>
                            </Col>
                            <Col md={5}>
                                <Form.Control as="textarea" name="ops_acc_manager_email_cc" rows={4} placeholder="Enter here..." {...register("ops_acc_manager_email_cc")} />
                                <span className="info">each line have 1 email id, press enter for next line</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Language</label>
                            </Col>
                            <Col md={5}>
                                <Form.Select name="language" {...register("language")}>
                                    <option value="0" >Default</option>
                                    <option value="1" >Chinese</option>
                                </Form.Select>
                            </Col>
                        </Row>
                        {approvalStatus == 9 && (
                            <Row>
                                <Col md={3}>
                                    <label>Do you want to change GAM onboarding date?</label>
                                </Col>
                                <Col md={5}>
                                    <Form.Select name="gam_onboarding" {...register("gam_onboarding")}>
                                        <option value="true" >Yes</option>
                                        <option value="false" >No</option>
                                    </Form.Select>
                                    <span className="info">In case of yes, onboarding date will be raplaced with current date. It will reflect on Publisher's GAM dashboard, date will be shown onboarding date onwards.</span>
                                </Col>
                            </Row>
                        )}
                        <Row>
                            <Col md={3}>
                                <label>Status</label>
                            </Col>
                            <Col md={5}>
                                {/* <Form.Select name="status" {...register("status")}>
                                    {
                                        invoiceSettingRef?.current?.approvalStatus !== 9 && (
                                            <option value={5}>Pending</option>
                                        )
                                    }
                                    {invoiceSettingRef?.current?.approvalStatus === 9 && !permissions?.includes(AUTH_CODE.invoiceSetting.approveInvoiceSetting) ? (
                                        <Form.Control value="Approved" disabled />
                                    ) : (
                                        <Form.Select name="status" {...register("status")}>
                                            <option value={5}>Pending</option>
                                            <option value={9}>Approved</option>
                                        </Form.Select>
                                    )
                                    //     <Permission code={AUTH_CODE.invoiceSetting.approveInvoiceSetting}>
                                    //     {
                                    //         invoiceSettingRef?.current?.id && (
                                    //             <option value={9}>Approve</option>
                                    //     )}
                                    // </Permission>
                                    }
                                </Form.Select> */}
                                {/* {invoiceSettingRef?.current?.approvalStatus === 9 &&
                                    !permissions?.includes(AUTH_CODE.invoiceSetting.approveInvoiceSetting) ? (
                                    <Form.Control value="Approved" disabled />
                                ) : (
                                    <Form.Select name="status" {...register("status")}>
                                        {invoiceSettingRef?.current?.approvalStatus !== 9 && (
                                            <option value={5}>Pending</option>
                                        )}

                                        <option value={9}>Approved</option>
                                    </Form.Select>
                                )} */}
                                {/* CASE 3 */}
                                {/* Invoice already approved and user has no approval permission */}
                                {currentStatus === 9 ? (
                                    <Form.Control value="Approved" disabled />
                                ) : (
                                    <Form.Select
                                        {...register("status")}
                                        defaultValue={currentStatus || 5}
                                    >
                                        {/* CASE 1 */}
                                        {/* New Invoice -> only Pending */}
                                        {/* Pending always visible */}
                                        <option value={5}>Pending</option>
                                        {/* CASE 2 */}
                                        {/* Existing invoice */}
                                        {/* Approve only for permission user */}
                                        {canApprove && invoiceSettingRef?.current?.id && (
                                            <option value={9}>Approved</option>
                                        )}
                                    </Form.Select>
                                )}
                            </Col>
                        </Row>
                    </Card>
                    {currentStatus === 9 && !canApprove ? (
                        // <Permission code={AUTH_CODE.invoiceSetting.approveInvoiceSetting} fallback={
                        <Alert variant="warning" className="mt-3">
                            Invoice is already approved and you don't have permission to update invoice setting.
                        </Alert>
                        // }>
                    ) : (
                        <>
                            <Button type="submit" onClick={showGamReviewAlert} variant="primary" disabled = {btnClicked} className="mt-3 submitBtn" size="lg">Update</Button>
                            <Button type="button" variant="secondary" className="mx-5 mt-3 cancelBtn" onClick={() => navigate("/dashboard")} style={{}}>Cancel</Button>
                        </>
                    )
                    }
                </form>
            </Card>
        </FormLoader>
    )
}

export default InvoiceSetting;